module.exports = __webpack_public_path__ + "static/icons/icon-caret-down-4926beb838ea8a307ef88a9f1727d8d7.svg";